/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('DOMContentLoaded', function () {
  var stickyWrapper = document.getElementById('sticky-add-to-cart');
  if (!stickyWrapper) return;
  var stickyButton = stickyWrapper.querySelector('.sticky-add-to-cart__button');
  var stickyQty = stickyWrapper.querySelector('input[name="quantity"]');
  var wishlist = stickyWrapper.querySelector('.wishlist-engine');
  var originalForm = document.querySelector('form.product-form');
  var originalButton = originalForm ? originalForm.querySelector('.product-form__add-button') : null;
  var originalQty = originalForm ? originalForm.querySelector('input[name="quantity"]') : null;

  function onStickyQtyChange() {
    if (!originalQty) return;
    originalQty.value = stickyQty.value;
    originalQty.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onOriginalQtyChange() {
    if (!stickyQty) return;
    stickyQty.value = originalQty.value;
  }

  function ensureOriginalElements() {
    originalForm = document.querySelector('form.product-form');
    originalButton = originalForm ? originalForm.querySelector('.product-form__add-button') : null;
    var newOriginalQty = originalForm ? originalForm.querySelector('input[name="quantity"]') : null;
    if (newOriginalQty !== originalQty) {
      if (originalQty) {
        originalQty.removeEventListener('change', onOriginalQtyChange);
      }
      originalQty = newOriginalQty;
      if (originalQty) {
        originalQty.addEventListener('change', onOriginalQtyChange);
      }
    }
  }

  function syncAvailability(available) {
    if (!stickyButton) return;
    stickyButton.disabled = !available;
    stickyButton.classList.toggle('button--disabled', !available);
    if (stickyQty) stickyQty.disabled = !available;
    var text = available ? stickyButton.dataset.addText : stickyButton.dataset.soldOutText;
    stickyButton.textContent = text;
  }

  function checkVisibility() {
    if (!originalButton || !document.body.contains(originalButton)) {
      ensureOriginalElements();
    }
    if (!originalButton) return;
    var rect = originalButton.getBoundingClientRect();
    var inView = rect.top <= window.innerHeight && rect.bottom >= 0;
    if (window.innerWidth <= 999 && !inView) {
      stickyWrapper.classList.add('visible');
    } else {
      stickyWrapper.classList.remove('visible');
    }
  }

  stickyButton.addEventListener('click', function () {
    if (originalButton && !stickyButton.disabled) {
      if (stickyQty && originalQty) {
        onStickyQtyChange();
      }
      originalButton.click();
    }
  });

  if (stickyQty) {
    stickyQty.addEventListener('change', onStickyQtyChange);
  }
  ensureOriginalElements();

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant;
    if (!variant) return;
    setTimeout(function () {
      ensureOriginalElements();
      syncAvailability(variant.available);
      if (stickyQty && originalQty) {
        stickyQty.value = originalQty.value;
        stickyQty.min = originalQty.getAttribute('min') || 1;
        stickyQty.step = originalQty.getAttribute('step') || 1;
        var maxAttr = originalQty.getAttribute('max');
        if (maxAttr != null) {
          stickyQty.max = maxAttr;
        } else {
          stickyQty.removeAttribute('max');
        }
      }
      if (wishlist) {
        wishlist.setAttribute('data-variant_id', variant.id);
      }
      checkVisibility();
    });
  });

  syncAvailability(originalButton ? !originalButton.disabled : true);
  if (stickyQty && originalQty) {
    stickyQty.value = originalQty.value;
    stickyQty.min = originalQty.getAttribute('min') || 1;
    stickyQty.step = originalQty.getAttribute('step') || 1;
    var maxAttrInit = originalQty.getAttribute('max');
    if (maxAttrInit != null) {
      stickyQty.max = maxAttrInit;
    } else {
      stickyQty.removeAttribute('max');
    }
  }

  document.addEventListener('scroll', checkVisibility, { passive: true });
  window.addEventListener('resize', checkVisibility);
  checkVisibility();
});

document.addEventListener('DOMContentLoaded', function () {
  function enhanceWishlistPopup(popup) {
    if (!popup || popup.classList.contains('wishlist-popup--garronda')) return;

    var inner = popup.querySelector('.wishlit-popupinr');
    var imageLink = popup.querySelector('.wishlist-p-left a');
    var image = popup.querySelector('.wishlist-p-left img');
    var right = popup.querySelector('.wishlist-p-right');

    if (!inner || !imageLink || !image || !right) return;

    popup.classList.add('wishlist-popup--garronda');

    var title = image.getAttribute('alt') || '';
    var productUrl = imageLink.getAttribute('href') || '#';

    right.innerHTML = '';

    var header = document.createElement('div');
    header.className = 'wishlist-popup__heading';
    header.innerHTML = '<span class="wishlist-popup__heading-icon" aria-hidden="true">❤</span><span>Produkt wurde zur Wunschliste hinzugefügt</span>';

    var details = document.createElement('div');
    details.className = 'wishlist-popup__details';

    var productTitle = document.createElement('a');
    productTitle.className = 'wishlist-popup__product-title';
    productTitle.href = productUrl;
    productTitle.textContent = title;

    var params = document.createElement('p');
    params.className = 'wishlist-popup__product-meta';
    params.textContent = 'Ausgewählte Variante wurde gespeichert';

    var button = document.createElement('a');
    button.className = 'wishlist-popup__button';
    button.href = '/apps/wishlist';
    button.innerHTML = '<span>Zur Wunschliste</span><span aria-hidden="true">♡</span>';

    details.appendChild(productTitle);
    details.appendChild(params);
    right.appendChild(header);
    right.appendChild(details);
    right.appendChild(button);
  }

  function scanWishlistPopups(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var popups = scope.matches && scope.matches('.wishlist-popup') ? [scope] : scope.querySelectorAll('.wishlist-popup');

    popups.forEach(enhanceWishlistPopup);
  }

  scanWishlistPopups(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          scanWishlistPopups(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var variantDataCache = new WeakMap();
  var suppressForms = new WeakSet();

  function getVariantData(picker) {
    if (!picker) return [];
    if (variantDataCache.has(picker)) {
      return variantDataCache.get(picker);
    }
    var script = picker.querySelector('script[data-variant-map]');
    if (!script) {
      variantDataCache.set(picker, []);
      return [];
    }
    var data;
    try {
      data = JSON.parse(script.textContent || '[]');
    } catch (error) {
      console.warn('Unable to parse variant data for picker', picker, error);
      data = [];
    }
    if (!Array.isArray(data)) {
      data = [];
    }
    for (var i = 0; i < data.length; i++) {
      var variant = data[i];
      var ids = Array.isArray(variant.option_value_ids) ? variant.option_value_ids : [];
      var normalized = [];
      for (var j = 0; j < ids.length; j++) {
        normalized.push(ids[j] == null ? '' : String(ids[j]));
      }
      variant.option_value_ids = normalized;
      if (typeof variant.inventory_quantity !== 'number') {
        if (variant.inventory_quantity == null || variant.inventory_quantity === '') {
          variant.inventory_quantity = null;
        } else {
          var parsedQuantity = parseInt(variant.inventory_quantity, 10);
          variant.inventory_quantity = isNaN(parsedQuantity) ? null : parsedQuantity;
        }
      }
    }
    variantDataCache.set(picker, data);
    return data;
  }

  function collectActiveOptionValueIds(form) {
    if (!form) return [];
    var elements = form.querySelectorAll(
      'input[data-option-position]:checked, input[data-option-position][type="hidden"], select[data-option-position]'
    );
    var list = Array.prototype.slice.call(elements);
    list.sort(function (a, b) {
      return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
    });
    return list.map(function (input) {
      return input.value == null ? '' : String(input.value);
    });
  }

  function hasInventory(variant) {
    if (!variant) return false;
    if (variant.inventory_quantity == null) {
      return !!variant.available;
    }
    return variant.inventory_quantity > 0 && variant.available !== false;
  }

  function pickPreferredVariant(candidates) {
    if (!candidates || !candidates.length) return null;
    for (var i = 0; i < candidates.length; i++) {
      if (hasInventory(candidates[i])) {
        return candidates[i];
      }
    }
    for (var j = 0; j < candidates.length; j++) {
      if (candidates[j].available) {
        return candidates[j];
      }
    }
    return candidates[0];
  }

  function findExactVariant(variants, optionIds) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var ids = Array.isArray(variant.option_value_ids) ? variant.option_value_ids : [];
      if (ids.length !== optionIds.length) {
        continue;
      }
      var match = true;
      for (var j = 0; j < ids.length; j++) {
        if (ids[j] !== optionIds[j]) {
          match = false;
          break;
        }
      }
      if (match) {
        return variant;
      }
    }
    return null;
  }

  function findFallbackVariant(variants, optionIds) {
    if (!variants.length) return null;
    for (var prefix = optionIds.length; prefix >= 0; prefix--) {
      var candidates = [];
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var ids = Array.isArray(variant.option_value_ids) ? variant.option_value_ids : [];
        var matchesPrefix = true;
        for (var j = 0; j < prefix; j++) {
          if (!optionIds[j]) {
            continue;
          }
          if (ids[j] !== optionIds[j]) {
            matchesPrefix = false;
            break;
          }
        }
        if (matchesPrefix) {
          candidates.push(variant);
        }
      }
      if (candidates.length) {
        var preferred = pickPreferredVariant(candidates);
        if (preferred) {
          return preferred;
        }
      }
    }
    return pickPreferredVariant(variants);
  }

  function updateOptionInputs(form, desiredOptionIds, currentOptionIds) {
    for (var index = 0; index < desiredOptionIds.length; index++) {
      var desiredValue = desiredOptionIds[index];
      var currentValue = currentOptionIds[index];
      if (!desiredValue || desiredValue === currentValue) {
        continue;
      }
      var position = index + 1;
      var inputs = form.querySelectorAll('[data-option-position="' + position + '"]');
      if (!inputs.length) {
        continue;
      }
      var first = inputs[0];
      if (first.tagName === 'SELECT') {
        if (first.value !== desiredValue) {
          first.value = desiredValue;
        }
        continue;
      }
      var matched = null;
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.value === desiredValue) {
          matched = input;
        }
      }
      if (matched) {
        matched.checked = true;
      } else if (first.type === 'hidden') {
        first.value = desiredValue;
      }
    }
  }

  function shouldAdjustVariant(variant) {
    if (!variant) {
      return true;
    }
    if (!variant.available) {
      return true;
    }
    if (variant.inventory_quantity == null) {
      return false;
    }
    return variant.inventory_quantity <= 0;
  }

  function onOptionChanged(event) {
    var target = event.target;
    if (!target || !target.matches('[data-option-position]')) {
      return;
    }
    var picker = target.closest('variant-picker');
    if (!picker) {
      return;
    }
    var formId = picker.getAttribute('form-id');
    if (!formId) {
      return;
    }
    var form = document.forms[formId];
    if (!form || suppressForms.has(form)) {
      return;
    }
    var variants = getVariantData(picker);
    if (!variants.length) {
      return;
    }
    var currentOptionIds = collectActiveOptionValueIds(form);
    if (!currentOptionIds.length) {
      return;
    }
    var selectedVariant = findExactVariant(variants, currentOptionIds);
    if (!shouldAdjustVariant(selectedVariant)) {
      return;
    }
    var fallback = findFallbackVariant(variants, currentOptionIds);
    if (!fallback) {
      return;
    }
    var desiredOptionIds = Array.isArray(fallback.option_value_ids) ? fallback.option_value_ids : [];
    var changed = false;
    for (var i = 0; i < desiredOptionIds.length; i++) {
      if (desiredOptionIds[i] !== currentOptionIds[i]) {
        changed = true;
        break;
      }
    }
    if (!changed) {
      return;
    }
    suppressForms.add(form);
    updateOptionInputs(form, desiredOptionIds, currentOptionIds);
    suppressForms.delete(form);
  }

  document.addEventListener('change', onOptionChanged, true);
});
